<template>
  <a-tree
    v-model:expandedKeys="expandedKeys"
    v-model:selectedKeys="selectedKeys"
    :load-data="onLoadData"
    :tree-data="treeData"
    show-icon
    :style="{ 'marginLeft': '16px' }"
    @select="onSelect"
  >
    <template #avatar="{ value }">
      <UserAvatar
        :avatar-url="value.avatarUrl"
        :size="20"
      />
    </template>
  </a-tree>
</template>

<script>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import {
  getMyDepartments as getMyDepartmentsApi,
  getHrbpDepartments as getHrbpDepartmentsApi,
  getDepartment as getDepartmentApi,
  getHrbpDepartment as getHrbpDepartmentApi
} from '@/graphql/department'
import UserAvatar from '@/components/UserAvatar'

export default {
  name: 'DepartmentTree',
  components: {
    UserAvatar
  },
  setup () {
    const router = useRouter()
    const store = useStore()
    const expandedKeys = ref([])
    const selectedKeys = ref([])
    const treeData = ref([])
    const user = computed(() => store.state.user)

    const getMyDepartments = (user.value.isHrbp || user.value.isHrd)
      ? getHrbpDepartmentsApi
      : getMyDepartmentsApi
    const getDepartment = (user.value.isHrbp || user.value.isHrd)
      ? getHrbpDepartmentApi
      : getDepartmentApi
    // const getDepartment = getDepartmentApi

    function getChildNodes (departments, employees) {
      const departmentNodes = departments.map(department => ({
        key: 'd-' + department.id,
        title: department.name,
        value: department,
        isLeaf: false
      }))

      const employeeNodes = employees.map(employee => ({
        key: 'e-' + employee.id,
        title: employee.name,
        value: employee,
        isLeaf: true,
        slots: {
          icon: 'avatar'
        }
      }))

      return [...employeeNodes, ...departmentNodes]
    }

    getMyDepartments()
      .then(rootDepartments => getDepartment(rootDepartments[0].id))
      .then(res => {
        treeData.value = getChildNodes(res.childIds, res.userIds)
      })
    // getDepartment(user.value.mainDepartmentId.id, false)
    //   .then(res => {
    //     treeData.value = getChildNodes(res.childIds || [], res.userIds)
    //   })

    function onLoadData (departmentNode) {
      return getDepartment(departmentNode.value.id)
        .then(res => {
          departmentNode.dataRef.children = getChildNodes(res.childIds || [], res.userIds)
        })
    }

    function onSelect (_, { node }) {
      if (node.isLeaf) {
        router.push({
          name: 'UserOkr',
          params: {
            userId: node.value.id
          }
        })
      }
    }

    return {
      expandedKeys,
      selectedKeys,
      treeData,
      onLoadData,
      onSelect
    }
  }
}
</script>

<style lang="less" scoped>
:deep(.ant-tree-icon__customize) {
  display: inline-flex !important;
  align-items: center;
}
</style>
